import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

export function ArticleWrapper({ id, title, component: Component }) {
  return (
    <article id={id} className={Styles.article}>
      <h2 className={Styles.title}>{title}</h2>
      <section className={Styles.content}>
        <Component />
      </section>
    </article>
  );
}

export default withComponentName(ArticleWrapper);
